// Reloads the app when a newer build has been deployed, so stale cached index.html is never used.
const CURRENT = process.env.REACT_APP_BUILD_ID;
const RELOAD_KEY = "df_version_reload";

async function check() {
  try {
    const res = await fetch(
      `${process.env.PUBLIC_URL || ""}/version.json?t=${Date.now()}`,
      { cache: "no-store" }
    );
    if (!res.ok) return;
    const { buildId } = await res.json();
    if (!buildId || buildId === CURRENT) {
      sessionStorage.removeItem(RELOAD_KEY);
      return;
    }
    // Guard against reload loops if the server keeps serving a stale index.html.
    if (sessionStorage.getItem(RELOAD_KEY) === buildId) return;
    sessionStorage.setItem(RELOAD_KEY, buildId);
    window.location.reload();
  } catch (e) {
    // Offline or version.json missing; ignore.
  }
}

export function startVersionCheck() {
  if (process.env.NODE_ENV !== "production" || !CURRENT) return;
  check();
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") check();
  });
}
